import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading-background" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: _ctx.animation }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["loading-overlay is-active", { 'is-full-page': _ctx.isFullPage }])
      }, [
        _hoisted_1,
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _hoisted_2
        ])
      ], 2), [
        [_vShow, _ctx.active]
      ])
    ]),
    _: 3
  }, 8, ["name"]))
}